
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Product {
  id: number;
  name: string;
  description: string;
  image: string;
  link: string;
}

interface RecommendedProductsProps {
  products: Product[];
}

const RecommendedProducts = ({ products }: RecommendedProductsProps) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="mt-28 pt-16 border-t border-border/60">
      <h3 className="text-2xl font-semibold mb-10">Recommended Products for You</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {products.map((product) => (
          <div key={product.id} className="border border-border/50 rounded-xl overflow-hidden hover:shadow-md transition-all group">
            <div className="aspect-[4/3] bg-muted/40 relative overflow-hidden">
              <img 
                src={product.image} 
                alt={product.name} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-3 right-3 bg-primary text-white text-xs font-bold px-3 py-1 rounded-full">
                RECOMMENDED
              </div>
            </div>
            <div className="p-6">
              <h4 className="font-medium text-lg mb-2">{product.name}</h4>
              <p className="text-muted-foreground mb-6 text-sm">{product.description}</p>
              <Button asChild className="w-full pulse-on-hover">
                <a 
                  href={product.link} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center justify-center"
                >
                  <ShoppingCart className="mr-2 h-4 w-4" />
                  Shop Now
                </a>
              </Button>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-12">
        <Button asChild variant="outline">
          <Link to="/shop" className="inline-flex items-center">
            <ShoppingCart className="mr-2 h-4 w-4" />
            View All Products
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default RecommendedProducts;
